import { useContext } from 'react';
import { Button, ButtonProps, Tooltip } from '@fluentui/react-components';
import { CopyRegular } from '@fluentui/react-icons';
import { ToastContext } from '@shared/contexts';

type CopyButtonProps = ButtonProps & {
  value: string; // text to copy
  label?: string; // e.g. "ID", "Log ID" (default: "ID")
  tooltip?: string; // override tooltip
  successMessage?: string; // override success toast
  errorMessage?: string; // override error toast
};

export const CopyToClipboardButton = ({
  value,
  label = 'ID',
  tooltip,
  successMessage,
  errorMessage,
  appearance = 'transparent',
  ...buttonProps
}: CopyButtonProps) => {
  const { show } = useContext(ToastContext);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      show('success', successMessage ?? `${label} copied to clipboard.`);
    } catch (e) {
      console.error('Copy failed', e);
      show('error', errorMessage ?? `Failed to copy ${label} to clipboard. Please try again.`);
    }
  };

  return (
    <Tooltip content={tooltip ?? `Click to copy the ${label}.`} relationship="label" showDelay={500}>
      <Button
        {...buttonProps}
        icon={buttonProps.icon ?? <CopyRegular />}
        appearance={appearance}
        aria-label={buttonProps['aria-label'] ?? `Copy ${label}`}
        disabled={!value}
        onClick={handleCopy}
      />
    </Tooltip>
  );
};
